"use client";

import { ChevronDownIcon } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

import { Panel, PanelHeader, PanelTitle } from "./panel";

export function CollapsiblePanel({
  id,
  title,
  count,
  defaultOpen = false,
  children,
}: {
  id?: string;
  title: React.ReactNode;
  count?: number;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Panel id={id}>
      <Collapsible defaultOpen={defaultOpen} className="group/panel">
        <PanelHeader className="flex items-center justify-between gap-2">
          <PanelTitle>
            {title}
            {typeof count === "number" && (
              <sup className="ml-1 font-mono text-sm text-muted-foreground select-none">
                ({count})
              </sup>
            )}
          </PanelTitle>

          <CollapsibleTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="group/trigger -mr-2 shrink-0 text-muted-foreground"
            >
              <span className="group-data-[state=open]/panel:hidden">
                Show more
              </span>
              <span className="hidden group-data-[state=open]/panel:inline">
                Show less
              </span>
              <ChevronDownIcon
                className="transition-transform group-data-[state=open]/panel:rotate-180"
                aria-hidden
              />
            </Button>
          </CollapsibleTrigger>
        </PanelHeader>

        <CollapsibleContent className="overflow-hidden duration-300 data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down">
          {children}
        </CollapsibleContent>
      </Collapsible>
    </Panel>
  );
}
